<template>
  <div class="scrollable-content--width">
    <roe-modal
      v-if="structureErrors || !isDataValid"
      wrap-class="popup-wrap"
      ref="errorPopup"
      :class="{
        'fix-popup-opened': openedFixForm || openedFixDeferralRateForm
      }"
      :close-on-click-outside="false"
    >
      <div
        class="popup-inner"
        :class="{
          'popup-inner--small': structureErrors,
          'popup-inner--big': !isDataValid
        }"
        style="overflow: auto;"
      >
        <roe-fix-participant-deferral-rate-form
          v-if="!openedFixForm"
          ref="fixParticipantDeferralRateForm"
          :opened="openedFixDeferralRateForm"
          @close="openedFixDeferralRateForm = false"
          @open="openedFixDeferralRateForm = true"
        >
        </roe-fix-participant-deferral-rate-form>
        <roe-fix-participant-form
          v-if="!openedFixDeferralRateForm"
          ref="fixParticipantForm"
          :opened="openedFixForm"
          @close="openedFixForm = false"
          @open="openedFixForm = true"
        ></roe-fix-participant-form>

        <div class="popup-header">
          <!-- STRUCTURE ERRORS HEADER -->
          <h4 v-if="structureErrors">
            Structure Errors ({{ structureErrors.length }})
          </h4>
          <!--ERRORS TABS-->
          <template v-else-if="!isDataValid">
            <div class="tab-buttons-wrap">
              <button
                class="tab-button"
                :class="{ current: errorsInfoView }"
                @click="showErrorsInfo()"
              >
                Errors Info
              </button>
              <button
                v-if="activeDeferralRateErrorsView"
                class="tab-button"
                :class="{ current: activeDeferralRateErrorsView }"
                @click="showActiveDeferralRateErrorsView()"
              >
                Active participants with MINOR Data Issues ({{
                  errorsInfo.ap_deferral_rate || 0
                }})
              </button>
              <button
                v-if="terminatedDeferralRateErrorsView"
                class="tab-button"
                :class="{ current: terminatedDeferralRateErrorsView }"
                @click="showTerminatedDeferralRateErrorsView()"
              >
                Terminated Participants ON/AFTER Current Year with MINOR Data
                Issues ({{ errorsInfo.tp_deferral_rate || 0 }})
              </button>
              <button
                v-if="activeErrorsView"
                class="tab-button"
                :class="{ current: activeErrorsView }"
                @click="showActiveErrors()"
              >
                Active participants with MAJOR Data Issues ({{
                  dataErrorsLength(activeErrors)
                }})
              </button>
              <button
                v-if="terminatedErrorsView"
                class="tab-button"
                :class="{ current: terminatedErrorsView }"
                @click="showTerminatedErrors()"
              >
                Terminated Participants ON/AFTER Current Year with MAJOR Data
                Issues ({{ dataErrorsLength(terminatedErrors) }})
              </button>
              <button
                v-if="terminatedBeforeCurrentYearErrorsView"
                class="tab-button"
                :class="{ current: terminatedBeforeCurrentYearErrorsView }"
                @click="showTerminatedErrors()"
              >
                Terminate participants PRIOR to CURRENT YEAR with MAJOR Data
                Issues ({{
                  dataErrorsLength(terminatedBeforeCurrentYearErrors)
                }})
              </button>
            </div>
          </template>
          <button class="btn-close" @click="$refs.errorPopup.close()"></button>
        </div>

        <div class="popup-content">
          <RoeSpinner v-if="isParticipantsLoading"></RoeSpinner>
          <!--STRUCTURE ERRORS CONTENT-->
          <p v-if="structureErrors" v-for="error in structureErrors">
            {{ error }}
          </p>
          <!--VALIDATION ERRORS CONTENT-->
          <template v-if="!structureErrors">
            <template v-if="errorsInfoView">
              <table>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Action - Rationale</th>
                    <th>Participants<br />Impacted</th>
                    <th>Assets<br />Impacted</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 0. Terminate participants EXCLUDED WHEN EXCLUDE ALL TERMINATED -->
                  <tr v-if="errorsInfo.tp_excluded > 0">
                    <td>Terminated participants</td>
                    <td>Excluded</td>
                    <td class="bold">{{ errorsInfo.tp_excluded }}</td>
                    <td class="bold">
                      {{ errorsInfo.tp_excluded_assets | currency }}
                    </td>
                    <td></td>
                  </tr>
                  <template v-else>
                    <!-- 1. Terminated participants PRIOR to Current Year EXCLUDED-->
                    <tr>
                      <td>Terminated participants PRIOR to Current Year</td>
                      <td>Excluded</td>
                      <td class="bold">
                        {{ errorsInfo.tp_before_current_year }}
                      </td>
                      <td class="bold">
                        {{
                          errorsInfo.tp_before_current_year_assets | currency
                        }}
                      </td>
                      <td></td>
                    </tr>
                    <!-- 2. Terminated participants PRIOR to Current Year-->
                    <tr>
                      <td>Terminated participants PRIOR to Current Year</td>
                      <td>Examine: Possible Rehires</td>
                      <td class="bold">
                        {{
                          errorsInfo.tp_before_current_year_over_75 +
                            errorsInfo.tp_before_current_year_invalid
                        }}
                      </td>
                      <td class="bold">
                        {{
                          (errorsInfo.tp_before_current_year_over_75_assets +
                            errorsInfo.tp_before_current_year_invalid_assets)
                            | currency
                        }}
                      </td>
                      <td>
                        <div class="btn-wrap">
                          <button
                            :class="{ 'btn-secondary': !containsErrors('terminatedBeforeCurrentYear'), 'btn-alert': containsErrors('terminatedBeforeCurrentYear') }"
                            @click="
                              showTerminatedBeforeCurrentYearDetails = !showTerminatedBeforeCurrentYearDetails
                            "
                          >
                            {{
                              showTerminatedBeforeCurrentYearDetails
                                ? "Сollapse"
                                : "Expand"
                            }}
                          </button>
                        </div>
                      </td>
                    </tr>
                    <template v-if="showTerminatedBeforeCurrentYearDetails">
                      <!-- 2.1 Participants Reaching Age 75	-->
                      <tr>
                        <td class="pl-8">Participants Reaching Age 75</td>
                        <td>Will be Excluded: "Already Retired"</td>
                        <td>{{ errorsInfo.tp_before_current_year_over_75 }}</td>
                        <td>
                          {{
                            errorsInfo.tp_before_current_year_over_75_assets
                              | currency
                          }}
                        </td>
                        <td></td>
                      </tr>
                      <!-- 2.2 Participants with MINOR Data Issues	-->
                      <tr>
                        <td class="pl-8">
                          Participants with MINOR Data Issues
                        </td>
                        <td>Examine: Can be Ignored, Fixed or Deleted</td>
                        <td>{{ 0 }}</td>
                        <td>{{ 0 | currency }}</td>
                        <td></td>
                      </tr>
                      <!-- 2.3 Participants with MAJOR Data Issues	-->
                      <tr>
                        <td class="pl-8">
                          Participants with MAJOR Data Issues
                        </td>
                        <td>Examine: Must be Fixed or Deleted</td>
                        <td>{{ errorsInfo.tp_before_current_year_invalid }}</td>
                        <td>
                          {{
                            errorsInfo.tp_before_current_year_invalid_asset
                              | currency
                          }}
                        </td>
                        <td>
                          <div
                            class="btn-wrap"
                            v-if="errorsInfo.tp_before_current_year_invalid"
                          >
                            <button
                              class="btn-secondary"
                              @click="showTerminatedBeforeCurrentYearErrors()"
                            >
                              Fix
                            </button>
                          </div>
                          <div
                            class="btn-wrap"
                            v-if="errorsInfo.tp_before_current_year_invalid"
                          >
                            <button
                              class="btn-alert"
                              @click="
                                destroyAllParticipants(
                                  'tp_before_current_year_invalid'
                                )
                              "
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <tr class="divider">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <!-- 3. Terminated participants NO EDITS PROBLEM -->
                    <tr>
                      <td>Terminated Participants ON/AFTER Current Year</td>
                      <td>Process: No Edit Issues</td>
                      <td class="bold">{{ errorsInfo.tp }}</td>
                      <td class="bold">
                        {{ errorsInfo.tp_assets | currency }}
                      </td>
                      <td></td>
                    </tr>
                    <!-- 4. Terminated Participants ON/AFTER Current Year -->
                    <tr>
                      <td>Terminated Participants ON/AFTER Current Year</td>
                      <td>Examine: Multiple Data Issues</td>
                      <td class="bold">
                        {{
                          errorsInfo.tp_over_75 +
                            errorsInfo.tp_deferral_rate +
                            errorsInfo.tp_invalid
                        }}
                      </td>
                      <td class="bold">
                        {{
                          (errorsInfo.tp_over_75_assets +
                            errorsInfo.tp_deferral_rate_assets +
                            errorsInfo.tp_invalid_assets)
                            | currency
                        }}
                      </td>
                      <td>
                        <div class="btn-wrap">
                          <button
                            :class="{ 'btn-secondary': !containsErrors('terminatedDetails'), 'btn-alert': containsErrors('terminatedDetails') }"
                            @click="
                              showTerminatedDetails = !showTerminatedDetails
                            "
                          >
                            {{ showTerminatedDetails ? "Collapse" : "Expand" }}
                          </button>
                        </div>
                      </td>
                    </tr>

                    <template v-if="showTerminatedDetails">
                      <!-- 4.1 Participants Reaching Age 75	 -->
                      <tr>
                        <td class="pl-8">
                          Terminated Participants ON/AFTER Current Year
                        </td>
                        <td>Will be Excluded: "Already Retired"</td>
                        <td>{{ errorsInfo.tp_over_75 }}</td>
                        <td>{{ errorsInfo.tp_over_75_assets | currency }}</td>
                        <td></td>
                      </tr>
                      <!-- 4.2 Participants with MINOR Data Issues -->
                      <tr>
                        <td class="pl-8">
                          Participants with MINOR Data Issues
                        </td>
                        <td>Examine: Can be Ignored, Fixed or Deleted</td>
                        <td>{{ errorsInfo.tp_deferral_rate }}</td>
                        <td>
                          {{ errorsInfo.tp_deferral_rate_assets | currency }}
                        </td>
                        <td>
                          <div
                            class="btn-wrap"
                            v-if="errorsInfo.tp_deferral_rate"
                          >
                            <button
                              class="btn-secondary"
                              @click="showTerminatedDeferralRateErrorsView()"
                            >
                              Fix
                            </button>
                          </div>
                          <div
                            class="btn-wrap"
                            v-if="errorsInfo.tp_deferral_rate"
                          >
                            <button
                              class="btn-alert"
                              @click="
                                destroyAllParticipants('tp_deferral_rate')
                              "
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <!-- 4.3 Participants with MAJOR Data Issues	 -->
                      <tr>
                        <td class="pl-8">
                          Terminated participants with MAJOR Data Issues
                        </td>
                        <td>Examine: Must be Fixed or Deleted</td>
                        <td>{{ errorsInfo.tp_invalid }}</td>
                        <td>{{ errorsInfo.tp_invalid_assets | currency }}</td>
                        <td>
                          <div class="btn-wrap" v-if="errorsInfo.tp_invalid">
                            <button
                              class="btn-secondary"
                              @click="showTerminatedErrors()"
                            >
                              Fix
                            </button>
                          </div>
                          <div class="btn-wrap" v-if="errorsInfo.tp_invalid">
                            <button
                              class="btn-alert"
                              @click="destroyAllParticipants('tp_invalid')"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </template>
                  <tr class="divider">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>

                  <!-- 5. Active Participants Process: No Edit Issues -->
                  <tr>
                    <td>Active participants</td>
                    <td>Process: No Edit Issues</td>
                    <td class="bold">{{ errorsInfo.ap }}</td>
                    <td class="bold">{{ errorsInfo.ap_assets | currency }}</td>
                    <td></td>
                  </tr>
                  <!-- 6. Active Participants Examine: Multiple Data Issues -->
                  <tr>
                    <td>Active participants</td>
                    <td>Examine: Multiple Data Issues</td>
                    <td class="bold">
                      {{
                        errorsInfo.ap_over_75 +
                          errorsInfo.ap_invalid +
                          errorsInfo.ap_deferral_rate
                      }}
                    </td>
                    <td class="bold">
                      {{
                        (errorsInfo.ap_over_75_assets +
                          errorsInfo.ap_invalid_assets +
                          errorsInfo.ap_deferral_rate_assets)
                          | currency
                      }}
                    </td>
                    <td>
                      <div class="btn-wrap">
                        <button
                          :class="{ 'btn-secondary': !containsErrors('activeDetails'), 'btn-alert': containsErrors('activeDetails') }"
                          @click="showActiveDetails = !showActiveDetails"
                        >
                          {{ showActiveDetails ? "Сollapse" : "Expand" }}
                        </button>
                      </div>
                    </td>
                  </tr>
                  <template v-if="showActiveDetails">
                    <!-- 6.1 Participants Reaching Age 75	 -->
                    <tr>
                      <td class="pl-8">Participants Reaching Age 75</td>
                      <td>Will be Excluded: "Already Retired"</td>
                      <td>{{ errorsInfo.ap_over_75 }}</td>
                      <td>{{ errorsInfo.ap_over_75_assets | currency }}</td>
                      <td></td>
                    </tr>
                    <!-- 6.2 Participants with MINOR Data Issues-->
                    <tr>
                      <td class="pl-8">Participants with MINOR Data Issues</td>
                      <td>Examine: Can be Ignored, Fixed or Deleted</td>
                      <td>{{ errorsInfo.ap_deferral_rate }}</td>
                      <td>
                        {{ errorsInfo.ap_deferral_rate_assets | currency }}
                      </td>
                      <td>
                        <div
                          class="btn-wrap"
                          v-if="errorsInfo.ap_deferral_rate"
                        >
                          <button
                            class="btn-secondary"
                            @click="showActiveDeferralRateErrorsView()"
                          >
                            Fix
                          </button>
                        </div>
                        <div
                          class="btn-wrap"
                          v-if="errorsInfo.ap_deferral_rate"
                        >
                          <button
                            class="btn-alert"
                            @click="destroyAllParticipants('ap_deferral_rate')"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                    <!--6.3 Participants with MAJOR Data Issues	-->
                    <tr>
                      <td class="pl-8">
                        Actives participants with MAJOR Data Issues
                      </td>
                      <td>Examine: Must be Fixed or Deleted</td>
                      <td>{{ errorsInfo.ap_invalid }}</td>
                      <td>{{ errorsInfo.ap_invalid_assets | currency }}</td>
                      <td>
                        <div class="btn-wrap" v-if="errorsInfo.ap_invalid">
                          <button
                            class="btn-secondary"
                            @click="showActiveErrors()"
                          >
                            Fix
                          </button>
                        </div>
                        <div class="btn-wrap" v-if="errorsInfo.ap_invalid">
                          <button
                            class="btn-alert"
                            @click="destroyAllParticipants('ap_invalid')"
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                  <tr class="divider">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <!-- TOTAL -->
                  <tr>
                    <td></td>
                    <td></td>
                    <td>
                      <b>{{ errorsInfo.total }}</b>
                    </td>
                    <td>
                      <b>{{ errorsInfo.total_assets | currency }}</b>
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </template>
            <template v-if="activeErrorsView">
              <roe-participants-error-list
                :errors="errors"
                :fixParticipantForm="fixParticipantForm"
              ></roe-participants-error-list>
            </template>
            <template v-if="terminatedErrorsView">
              <roe-participants-error-list
                :errors="errors"
                :fixParticipantForm="fixParticipantForm"
              ></roe-participants-error-list>
            </template>
            <template v-if="terminatedBeforeCurrentYearErrorsView">
              <roe-participants-error-list
                :errors="errors"
                :fixParticipantForm="fixParticipantForm"
              ></roe-participants-error-list>
            </template>
            <template v-if="activeDeferralRateErrorsView">
              <roe-deferral-rate-error-list
                :errors="errors"
                :fixParticipantForm="fixParticipantForm"
              ></roe-deferral-rate-error-list>
            </template>
            <template v-if="terminatedDeferralRateErrorsView">
              <roe-deferral-rate-error-list
                :errors="errors"
                :fixParticipantForm="fixParticipantForm"
              ></roe-deferral-rate-error-list>
            </template>
          </template>
        </div>

        <!--FOOTER -->
        <template v-if="!structureErrors">
          <div v-if="activeErrorsView" class="popup-footer with-pagination">
            <pagination
              class="pagination"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :options="{
                texts: { count: '' },
                chunk: 10,
                chunksNavigation: 'fixed',
                edgeNavigation: false
              }"
              :records="currentErrors.length"
            />
            <div>
              <button
                class="btn btn-secondary"
                @click="ignoreAllParticipants('ap_invalid')"
              >
                Ignore All
              </button>
              <button
                class="btn-alert"
                @click="destroyAllParticipants('ap_invalid')"
              >
                Delete All
              </button>
            </div>
          </div>
          <div v-if="terminatedErrorsView" class="popup-footer with-pagination">
            <pagination
              class="pagination"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :options="{
                texts: { count: '' },
                chunk: 10,
                chunksNavigation: 'fixed',
                edgeNavigation: false
              }"
              :records="currentErrors.length"
            />
            <div>
              <button
                class="btn btn-secondary"
                @click="ignoreAllParticipants('tp_invalid')"
              >
                Ignore All
              </button>
              <button
                class="btn-alert"
                @click="destroyAllParticipants('tp_invalid')"
              >
                Delete All
              </button>
            </div>
          </div>
          <div
            v-if="terminatedBeforeCurrentYearErrorsView"
            class="popup-footer with-pagination"
          >
            <pagination
              class="pagination"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :options="{
                texts: { count: '' },
                chunk: 10,
                chunksNavigation: 'fixed',
                edgeNavigation: false
              }"
              :records="currentErrors.length"
            />
            <div>
              <button
                class="btn btn-secondary"
                @click="ignoreAllParticipants('tp_before_current_year_invalid')"
              >
                Ignore All
              </button>
              <button
                class="btn-alert"
                @click="
                  destroyAllParticipants('tp_before_current_year_invalid')
                "
              >
                Delete All
              </button>
            </div>
          </div>
          <div
            v-if="activeDeferralRateErrorsView"
            class="popup-footer with-pagination"
          >
            <pagination
              class="pagination"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :options="{
                texts: { count: '' },
                chunk: 10,
                chunksNavigation: 'fixed',
                edgeNavigation: false
              }"
              :records="currentErrors.length"
            />
            <div>
              <button
                class="btn btn-secondary"
                @click="ignoreAllParticipants('ap_deferral_rate')"
              >
                Ignore All
              </button>
              <button
                class="btn-alert"
                @click="destroyAllParticipants('ap_deferral_rate')"
              >
                Delete All
              </button>
            </div>
          </div>
          <div
            v-if="terminatedDeferralRateErrorsView"
            class="popup-footer with-pagination"
          >
            <pagination
              class="pagination"
              v-model="pagination.page"
              :per-page="pagination.perPage"
              :options="{
                texts: { count: '' },
                chunk: 10,
                chunksNavigation: 'fixed',
                edgeNavigation: false
              }"
              :records="currentErrors.length"
            />
            <div>
              <button
                class="btn btn-secondary"
                @click="ignoreAllParticipants('tp_deferral_rate')"
              >
                Ignore All
              </button>
              <button
                class="btn-alert"
                @click="destroyAllParticipants('tp_deferral_rate')"
              >
                Delete All
              </button>
            </div>
          </div>
          <div v-if="errorsInfoView" class="popup-footer">
            <file-upload
              name="uploadFixed"
              class="btn btn-secondary"
              :drop="true"
              @input-file="uploadFixedParticipants"
              ref="upload"
            >
              <b>Upload Fixed</b>
            </file-upload>
            <button class="btn-alert" @click="downloadAll">Download All</button>
          </div>
        </template>
      </div>
    </roe-modal>

    <div
      class="drag-n-drop"
      :class="{ active: $refs.upload && $refs.upload.dropActive }"
      @dragover.prevent
      @dragenter.prevent
      @dragleave.prevent
      @drop="handleDrop"
    >
      <img
        v-if="$refs.upload && $refs.upload.dropActive"
        src="@/assets/ico/ico-upload.svg"
        alt="upload"
      />
      <img v-else src="@/assets/ico/ico-xls.svg" alt="xls" />

      <template v-if="!isParticipantsLoading">
        <template v-if="participantFile">
          <h4>{{ participantFile.name }}</h4>

          <div v-if="structureErrors" class="drag-n-drop-error">
            Incorrect file structure
            <button class="btn-link" @click="$refs.errorPopup.open()">
              View details
            </button>
          </div>

          <div v-if="!isDataValid" class="drag-n-drop-error">
            Incorrect file data
            <button class="btn-link" @click="$refs.errorPopup.open()">
              View details
            </button>
          </div>

          <p>Drag & Drop to add another file or</p>
        </template>

        <template v-else>
          <div
            v-if="!participantFile && showAllErrors"
            class="drag-n-drop-error"
          >
            Need to upload a file
          </div>
          <p>Drag & Drop Excel file with participant data or</p>
        </template>
        <a
          href="javascript:void(0);"
          class="btn-link"
          @click.stop="$refs.includeTerminatedModal.open"
        >
          <span>Choose file</span>
        </a>
      </template>
      <div v-else>
        <h4>{{ participantFile.name }}</h4>
        <template
          v-if="serverMessage === 'uploading' || serverMessage === 'saving'"
        >
          <roe-three-dots-animation>
            {{
              serverMessage === "uploading"
                ? "Uploading data"
                : "Parse and saving"
            }}
          </roe-three-dots-animation>
        </template>
        <p v-else>{{ serverMessage }}</p>
      </div>
    </div>
    <roe-include-terminated-modal
      ref="includeTerminatedModal"
      :validate-participants="validateParticipants"
    ></roe-include-terminated-modal>
  </div>
</template>

<script>
import {
  SAVE_PARTICIPANTS,
  UPLOAD_FIXED_PARTICIPANTS,
  DESTROY_ALL_PARTICIPANTS,
  IGNORE_ALL_PARTICIPANTS,
  FETCH_INVALID_PARTICIPANTS,
  DOWNLOAD_INVALID_PARTICIPANTS
} from "@/store/actions.type";
import { mapGetters, mapMutations } from "vuex";
import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";
import RoeFixParticipantForm from "@/components/participants/FixParticipantForm";
import RoeModal from "@/components/_shared/Modal";
import RoeParticipantsErrorList from "@/components/participants/ErrorList";
import RoeThreeDotsAnimation from "@/components/_shared/ThreeDotsAnimation";
import WebNotificationsChannelMixin from "@/components/_shared/mixins/WebNotificationsChannelMixin";
import RoeIncludeTerminatedModal from "@/components/participants/IncludeTerminatedModal";
import RoeDeferralRateErrorList from "@/components/participants/DeferralRateErrorList";
import RoeFixParticipantDeferralRateForm from "@/components/participants/FixParticipantDeferralRateForm";
import RoeSpinner from "../_shared/Spinner";

export default {
  name: "RoeUploadParticipantsForm",
  mixins: [WebNotificationsChannelMixin],
  data() {
    return {
      openedFixForm: false,
      openedFixDeferralRateForm: false,
      errorsInfoView: true,
      activeErrorsView: false,
      includeTerminated: true,
      terminatedErrorsView: false,
      terminatedBeforeCurrentYearErrorsView: false,
      activeDeferralRateErrorsView: false,
      terminatedDeferralRateErrorsView: false,
      showActiveDetails: false,
      showTerminatedDetails: false,
      showTerminatedBeforeCurrentYearDetails: false,
      pagination: {
        page: 1,
        perPage: 100
      },
      fixParticipantForm: null,
      errorSections: {
        'terminatedBeforeCurrentYear': ['tp_before_current_year_invalid'],
        'terminatedDetails':['tp_deferral_rate', 'tp_invalid'],
        'activeDetails': ['ap_deferral_rate', 'ap_invalid']
      }
    };
  },
  components: {
    RoeSpinner,
    RoeFixParticipantDeferralRateForm,
    RoeIncludeTerminatedModal,
    RoeThreeDotsAnimation,
    RoeParticipantsErrorList,
    RoeModal,
    RoeFixParticipantForm,
    RoeDeferralRateErrorList
  },
  created() {
    this.setNextButtonState({ isInvalid: !this.participantFile });
  },
  mounted() {
    this.$store.dispatch(
      FETCH_INVALID_PARTICIPANTS,
      this.$router.currentRoute.params.id
    );
  },
  computed: {
    ...mapGetters([
      "isParticipantsLoading",
      "structureErrors",
      "isDataValid",
      "activeErrors",
      "terminatedErrors",
      "terminatedBeforeCurrentYearErrors",
      "activeDeferralRate",
      "terminatedDeferralRate",
      "errorsInfo",
      "maxDeferralRate",
      "participantFile",
      "showAllErrors"
    ]),
    maxDeferralRateFormat() {
      return `${Number((this.maxDeferralRate * 100).toFixed(2))}%`;
    },
    currentErrors() {
      if (this.activeErrorsView) return this.activeErrors;
      if (this.terminatedErrorsView) return this.terminatedErrors;
      if (this.terminatedBeforeCurrentYearErrorsView)
        return this.terminatedBeforeCurrentYearErrors;
      if (this.activeDeferralRateErrorsView) return this.activeDeferralRate;
      if (this.terminatedDeferralRateErrorsView)
        return this.terminatedDeferralRate;

      return [];
    },
    errors() {
      return this.currentErrors.slice(
        (this.pagination.page - 1) * this.pagination.perPage,
        this.pagination.page * this.pagination.perPage
      );
    }
  },
  methods: {
    ...mapMutations({
      setNextButtonState: SET_INVALID_FORM_STATE
    }),
    validateParticipants(newFile, isTerminatedIncluded) {
      this.resetServerMessage();
      if (newFile) {
        this.$store.dispatch(SAVE_PARTICIPANTS, {
          file: newFile.file,
          includeTerminated: isTerminatedIncluded,
          reportId: this.$router.currentRoute.params.id
        });
      }
    },
    uploadFixedParticipants(newFile) {
      this.resetServerMessage();
      if (newFile) {
        this.$store.dispatch(UPLOAD_FIXED_PARTICIPANTS, {
          file: newFile.file,
          reportId: this.$router.currentRoute.params.id
        });
      }
    },
    downloadAll() {
      this.$store.dispatch(
        DOWNLOAD_INVALID_PARTICIPANTS,
        this.$router.currentRoute.params.id
      );
    },
    destroyAllParticipants(errorType) {
      this.$store.dispatch(DESTROY_ALL_PARTICIPANTS, {
        reportId: this.$router.currentRoute.params.id,
        errorType: errorType
      });
    },
    ignoreAllParticipants(errorType) {
      this.$store.dispatch(IGNORE_ALL_PARTICIPANTS, {
        reportId: this.$router.currentRoute.params.id,
        errorType: errorType
      });
    },
    dataErrorsLength(errors) {
      return errors.map(x => x.errors).flat().length;
    },
    containsErrors(section) {
      return this.errorSections[section].some(error => this.errorsInfo[error]);
    },
    // TODO: Create component for tabs
    showErrorsInfo() {
      this.hideAllTabs();
      this.errorsInfoView = true;
    },
    showActiveErrors() {
      this.hideAllTabs();
      this.activeErrorsView = true;
      this.fixParticipantForm = this.$refs.fixParticipantForm;
    },
    showTerminatedErrors() {
      this.hideAllTabs();
      this.terminatedErrorsView = true;
      this.fixParticipantForm = this.$refs.fixParticipantForm;
    },
    showTerminatedBeforeCurrentYearErrors() {
      this.hideAllTabs();
      this.terminatedBeforeCurrentYearErrorsView = true;
      this.fixParticipantForm = this.$refs.fixParticipantForm;
    },
    showActiveDeferralRateErrorsView() {
      this.hideAllTabs();
      this.activeDeferralRateErrorsView = true;
      this.fixParticipantForm = this.$refs.fixParticipantDeferralRateForm;
    },
    showTerminatedDeferralRateErrorsView() {
      this.hideAllTabs();
      this.terminatedDeferralRateErrorsView = true;
      this.fixParticipantForm = this.$refs.fixParticipantDeferralRateForm;
    },
    hideAllTabs() {
      this.errorsInfoView = false;
      this.terminatedErrorsView = false;
      this.terminatedBeforeCurrentYearErrorsView = false;
      this.activeErrorsView = false;
      this.activeDeferralRateErrorsView = false;
      this.terminatedDeferralRateErrorsView = false;
    },
    handleDrop(event) {
      event.preventDefault();
      const file = event.dataTransfer.files[0];
      this.validateParticipants({file: file}, true); // include terminated by default
    }
  }
};
</script>
